import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 .833a9.169 9.169 0 0 1 6.482 15.65A9.168 9.168 0 1 1 10 .832m-5.252 15.23a8.022 8.022 0 0 0 13.219-5.132l.034-.358h-7.764zM9.427 2a8.02 8.02 0 0 0-5.489 13.252l5.489-5.49zm1.146 7.427h7.428A8.02 8.02 0 0 0 10.573 2z"
    }, null, -1)
  ]))]))
}
export default { render: render }